module.exports = __webpack_public_path__ + "img/xiuxian_3.a5d183fd.jpg";